"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInvite = void 0;

var _lib = require("../lib");

var _documents = require("./documents");

var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useInvite = token => {
  var _useQuery = (0, _lib.useQuery)(_documents.INVITE_INFO, {
    variables: {
      inviteToken: token
    },
    fetchPolicy: 'network-only'
  }),
      {
    data
  } = _useQuery,
      rest = _objectWithoutProperties(_useQuery, _excluded);

  var inviteInfo = data === null || data === void 0 ? void 0 : data.inviteInfo;
  var {
    mutate
  } = (0, _lib.useMutation)(_documents.RESPOND_TO_ORGANIZATION_INVITE);

  var accept = () => mutate({
    inviteToken: token,
    accept: true
  });

  var decline = () => mutate({
    inviteToken: token,
    accept: false
  });

  return _objectSpread({
    inviteInfo,
    accept,
    decline
  }, rest);
};

exports.useInvite = useInvite;